import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from "@angular/router";
import { LocalStorageService } from '../services/localstorage.service';
import { CONFIG_PAGES } from 'src/environments/config-envs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public userGuid = '';
  private usuario: any;

  mensagens: any = []

  constructor(private route: ActivatedRoute,
    private routeRedirect: Router,
    private authenticationService: AuthenticationService,
    private localStoreService: LocalStorageService) { }

  ngOnInit(): void {
    this.login();
  }

  async login() {
    await this.route.queryParams
      .subscribe(async params => {
        if (params['userGuid'] != null) {
          this.userGuid = params['userGuid'];
          var dados = await this.authenticationService.getLogin(this.userGuid)
          if (dados.sucesso) {
            this.localStoreService.setItem('userData', JSON.stringify(dados));
            this.localStoreService.setItem('guid', dados.retorno.guid);
            if (params['cmdName'] != null) {
              this.localStoreService.setCmdNameActually(params['cmdName']);
              var paginaDestino = CONFIG_PAGES.find(d => d.id == params['cmdName'])?.pagina;
              if (paginaDestino == null || paginaDestino == undefined)
                paginaDestino = "/";

              console.log(paginaDestino);
              this.routeRedirect.navigate([paginaDestino]);
            }
          }else{
            this.mensagens = ["Problemas ao entrar na tela, tente logar novamente."]
          }
        }
      }
      );
  }
}
